/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import './GrantViewAccess.scss';

import isEmpty from 'lodash/isEmpty';
import { bool, object } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import ZeroState from 'components/layouts/Preferences/GrantViewAccess/ZeroState/ZeroState';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import { getAccountsById } from 'state/account/AccountSelectors';
import {
  clearGrantViewAccessAddUserAuth,
  setViewAccessSelection,
  resetViewAccessSelections,
  resetGrantViewAccessAddUserAuth,
  resetDeleteGrantViewAccessUser,
  resetGrantViewAccessUpdateRelationships
} from 'state/grantViewAccess/GrantViewAccessActions';
import {
  getActiveCustomerIndex,
  getActiveSelections,
  getGrantViewAccessDeleteUserStatus,
  getShouldDisableSave,
  getViewRelationships,
  hasGrantViewRelationships,
  getModifiedActiveSelections,
  generateGVAEditPayload
  } from 'state/grantViewAccess/GrantViewAccessSelectors';
import {
  getCustomer,
  getPrimaryEmailAddress
} from 'state/customer/CustomerSelectors';
import {
  captureGVABusinessEvent,
  deleteGrantViewAccessUser,
  getPreferencesViewRelationships
} from 'services/Rest';
import {
  buildBusinessEvent,
  deleteUserPayload,
  GRANT_VIEW_EVENT_TYPES,
  updateAccountViewAccess
} from 'services/GrantViewAccess';
import Store from 'state/Store';
import { gvaAddNewButton } from 'services/FeatureFlags';
import { clearTouchedFields } from 'state/validation/ValidationActions';
import BeaconUserFlow from './NewUserFlow/BeaconUserFlow';
import SummaryView from 'components/layouts/Preferences/GrantViewAccess/SummaryView/SummaryView';
import BeaconCancelConfirmationModal from 'components/shared/CancelConfirmationModal/BeaconCancelConfirmationModal ';
import { getView, isSalesforceRepEnabled } from 'state/view/ViewSelectors';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import ProfileMaintenance from '../ProfileMaintenance';
import DeleteGVAUserModal from './DeleteGVAUserModal/DeleteGVAUserModal';
import BeaconFixedSubmitFooter from '../shared/FixedSubmitFooter/BeaconFixedSubmitFooter';
import DeleteConfirmationModal from 'components/shared/DeleteConfirmationModal/DeleteConfirmationModal';
import CancelConfirmationModal from 'components/shared/CancelConfirmationModal/CancelConfirmationModal';
import FixedSubmitFooter from '../shared/FixedSubmitFooter/FixedSubmitFooter';
import NewUserFlow from './NewUserFlow/NewUserFlow';
import { AAMBeaconButton } from 'components/shared/Beacon';

class GrantViewAccess extends React.Component {
  state = {
    activeCustomer: null,
    showAddNewUserFlow: false,
    showDeleteUserModal: false,
    showCancelConfirmationModal: false,
    userToDelete: null
  };

  componentDidMount() {
    getPreferencesViewRelationships();
  }

  handleStartAddNewUserFlow = () => {
    const modal = document.getElementById('gva_new_user_modal');
    if (modal !== null){
       modal.show();
    }
    this.setState({ showAddNewUserFlow: true });
  };

  closeNewUserFlow = () => {
    const modal = document.getElementById('gva_new_user_modal');
    if (modal) {
      modal.close();
    }
    this.setState({ showAddNewUserFlow: false });
    
  };

  closeCallback = () => {
    this.setState({ showAddNewUserFlow: false });
    Store.dispatch(resetGrantViewAccessAddUserAuth());
  };

  handleClose = () => {
    const { touchedFields } = this.props;
    if (!isEmpty(touchedFields)) {
      if (window.confirm('Your changes will not be saved if you proceed.')) {
        this.closeNewUserFlow();
        Store.dispatch(clearTouchedFields());
      }
    } else {
      this.closeNewUserFlow();
      Store.dispatch(resetGrantViewAccessAddUserAuth());
    }
  };

  resetNewuserForm = () => {
    Store.dispatch(clearGrantViewAccessAddUserAuth());
    Store.dispatch(resetGrantViewAccessAddUserAuth());
    Store.dispatch(resetGrantViewAccessUpdateRelationships());
  }

  handleSaveAndClose = () => {
    Store.dispatch(clearTouchedFields());
    this.closeNewUserFlow();
    this.resetNewuserForm();
    getPreferencesViewRelationships();
  };

  handleSubmitCancelConfirmation = () => {
    const modal = document.getElementById(
      'grant-view-access-cancel-confirmation-modal'
    );
    if (modal) {
      modal.close();
    }
    const { history } = this.props;
    Store.dispatch(setViewAccessSelection(null));
    Store.dispatch(resetViewAccessSelections());
    history.push('/profile');
  };

  handleSubmitCancel = () => {
    this.setState({ showCancelConfirmationModal: true });
  };

   handleCloseDeleteModal = () => {
    this.setState({ showDeleteUserModal: false, userToDelete: null });
    const modal = document.getElementById('delete-user-modal');
    if (modal) {
      modal.close();
    }
  };

  handleCancelConfirmation = () => {
    const modal = document.getElementById(
      'grant-view-access-cancel-confirmation-modal'
    );
    this.setState({ showCancelConfirmationModal: false })
    if (modal) {
      modal.close();
    }
  };

  clearActiveCustomer = () => Store.dispatch(setViewAccessSelection(null));

  hasActiveCustomer = () => this.props.activeCustomerIndex !== null;

  isActiveCustomer = (customerIndex) =>
    this.hasActiveCustomer() &&
    this.props.activeCustomerIndex === customerIndex;

  handleCancelDelete = () => {
    this.setState({
      showDeleteUserModal: false,
      userToDelete: null
    });
  };

  handleCloseDelete = () => {
    const { customerEmail: email, view, customer: user } = this.props;
    const { accounts = [] } = this.state.userToDelete || {};
    const event = buildBusinessEvent(
      GRANT_VIEW_EVENT_TYPES.DELETE,
      email,
      user,
      Array.isArray(accounts) ? accounts : [accounts],
      view
    );
    this.setState({
      showDeleteUserModal: false,
      userToDelete: null
    });

    getPreferencesViewRelationships();

    captureGVABusinessEvent(event);
  };

  handleCloseDeleteV1 = (data, customer, email, accounts, user, view) => {
    this.setState({
      showDeleteUserModal: false,
      userToDelete: null
    });

    getPreferencesViewRelationships();
    const event = buildBusinessEvent(
      GRANT_VIEW_EVENT_TYPES.DELETE,
      email,
      user,
      accounts,
      view
    );
    captureGVABusinessEvent(event);
  }

  handleConfirmDelete = (viewRelationship) => {
    this.setState({
      showDeleteUserModal: true,
      userToDelete: viewRelationship
    });
  };
  handleSubmitDelete = () => {
    const { customerEmail, customer: user, view } = this.props;
    if(this.state.userToDelete !== null) {
    const { customer: customerToDelete, accounts } = this.state.userToDelete;
    const deletePayload = deleteUserPayload(customerToDelete, accounts);
    const { bepAccounts, customer, viewAccesses } = deletePayload;
    const modal = document.getElementById('delete-user-modal');
    if (modal) {
      modal.close();
    }
    const payload = {
      customer,
      viewAccesses
    };

      deleteGrantViewAccessUser(payload, (data) => {
        Store.dispatch(resetDeleteGrantViewAccessUser());
        this.handleCloseDeleteV1(
          data,
          customer,
          customerEmail,
          bepAccounts,
          user,
          view
        );
    })
  }
}

  submitEdits = () => {
    const {
      accountsById,
      activeCustomerIndex,
      customerEmail,
      viewRelationships,
      customer: user,
      generateGVAEditPayload,
      view
    } = this.props;
    
    const { customer } = viewRelationships[activeCustomerIndex];
    const selections = Object.entries(generateGVAEditPayload) || [];
    const accounts = selections.reduce((result, [accountId]) => {
      const account = accountsById[accountId];
      if (account) {
        result.push(account);
      }
      return result;
    }, []);

    const event = buildBusinessEvent(
      GRANT_VIEW_EVENT_TYPES.UPDATE,
      customerEmail,
      user,
      accounts,
      view
    );

    updateAccountViewAccess(customer, generateGVAEditPayload, () => {
      getPreferencesViewRelationships();
      captureGVABusinessEvent(event);
    });
  };

  render() {
    const {
      hasGrantedAccounts,
      viewRelationships,
      shouldDisableSave,
      requestStatus,
      activeCustomerIndex
    } = this.props;

    const {
      showAddNewUserFlow,
      showCancelConfirmationModal,
      userToDelete,
      showDeleteUserModal
    } = this.state;

    const fullName =
      userToDelete && userToDelete.customer
        ? userToDelete.customer.fullName
        : '';

    const deletePrompt = `Are you sure you want to delete ${fullName}?`;

    const disableAdd = activeCustomerIndex != null;

    const isGVAAddEnabled = gvaAddNewButton();

    if (
      !hasGrantedAccounts &&
      !isGVAAddEnabled &&
      requestStatus['viewRelationships'] === REQUEST_STATES.received
    ) {
      return <ProfileMaintenance />;
    }

    return (
      <span className="grant-view-access-page beacon-on-lighter">
        <PreferencesHeader>
          <div className="grant-view-access-header">
            <div className="grant-view-access-header-tab">
              <span className="grant-view-access-header-tab-text">
                Grant View Access
              </span>
              {hasGrantedAccounts && isGVAAddEnabled && (
                <div className="grant-view-access-header-tab-gva">
                  <AAMBeaconButton
                    id="add-new-user"
                    variant="primary"
                    onBeaconEventClick={this.handleStartAddNewUserFlow}
                    disabled={disableAdd}
                  >
                    Add New User
                  </AAMBeaconButton>
                </div>
              )}
            </div>
            {!isGVAAddEnabled && (
              <div className="grant-view-access-header-sub-text">
                Currently you are unable to add a new user. We are working on
                this feature and it will be available soon.
              </div>
            )}
          </div>
        </PreferencesHeader>
        {hasGrantedAccounts ? (
          viewRelationships.map((viewRelationship, i) => (
            <SummaryView
              clearActiveCustomer={this.clearActiveCustomer}
              deleteCustomer={() => this.handleConfirmDelete(viewRelationship)}
              isActive={this.isActiveCustomer(i)}
              hasActive={this.hasActiveCustomer()}
              key={i}
              setActiveCustomer={() =>
                Store.dispatch(setViewAccessSelection(i))
              }
              activeCustomerIndex={activeCustomerIndex}
              {...viewRelationship}
            />
          ))
        ) : (
          <ZeroState addNewUser={this.handleStartAddNewUserFlow} />
        )}

        {isGVAAddEnabled ? (
          <Fragment>
            {showAddNewUserFlow && (
              <BeaconUserFlow
                onClose={this.handleClose}
                closeCallback={this.closeCallback}
                onSave={this.handleSaveAndClose}
              />
            )}
            {this.state.showDeleteUserModal && (
              <DeleteGVAUserModal
                onCancel={this.handleCloseDeleteModal}
                onSubmit={this.handleSubmitDelete}
                userToDelete={this.state.userToDelete}
              />
            )}
            {
              <BeaconCancelConfirmationModal
                cancelPrompt="You haven’t saved your changes."
                cancelTitle="Are you sure you want to leave?"
                onCancel={this.handleCancelConfirmation}
                onContinue={this.handleSubmitCancelConfirmation}
                operationName="updateGrantViewAccess"
                showModal={showCancelConfirmationModal}
                continueText="Yes, Leave"
                cancelText="No, Keep Editing"
              />
            }
            <BeaconFixedSubmitFooter
              cancel={this.handleSubmitCancel}
              requestStatusKey="updateViewRelationships"
              shouldShow={this.hasActiveCustomer()}
              shouldDisableSubmit={shouldDisableSave}
              submit={this.submitEdits}
            />
          </Fragment>
        ) : (
          <Fragment>
            {/*Temporary Disabling Add New User Flow*/}
            {showAddNewUserFlow && (
              <NewUserFlow
                onClose={this.handleClose}
                onSave={this.handleSaveAndClose}
              />
            )}
            <DeleteConfirmationModal
              deletePrompt={deletePrompt}
              onCancel={this.handleCancelDelete}
              onSubmit={this.handleSubmitDelete}
              requestStatusKey="deleteGrantViewAccessUser"
              showModal={showDeleteUserModal}
              shouldDisable
            />

            <CancelConfirmationModal
              cancelPrompt="You haven’t saved your changes."
              cancelTitle="Are you sure you want to leave?"
              onCancel={this.handleCancelConfirmation}
              onContinue={this.handleSubmitCancelConfirmation}
              operationName="updateGrantViewAccess"
              showModal={showCancelConfirmationModal}
              continueText="Yes, Leave"
              cancelText="No, Keep Editing"
            />

            <FixedSubmitFooter
              cancel={this.handleSubmitCancel}
              requestStatusKey="updateViewRelationships"
              shouldShow={this.hasActiveCustomer()}
              shouldDisableSubmit={shouldDisableSave}
              submit={this.submitEdits}
            />
          </Fragment>
        )}
      </span>
    );
  }
}

GrantViewAccess.propTypes = {
  hasGrantedAccounts: bool.isRequired,
  touchedFields: object.isRequired
};

const mapStateToProps = (state) => ({
  isSalesforceRepEnabled: isSalesforceRepEnabled(state),
  accountsById: getAccountsById(state),
  activeCustomerIndex: getActiveCustomerIndex(state),
  activeSelections: getActiveSelections(state),
  customerEmail: getPrimaryEmailAddress(state).address || '',
  grantViewAccessDeleteUserStatus: getGrantViewAccessDeleteUserStatus(state),
  hasGrantedAccounts: hasGrantViewRelationships(state),
  requestStatus: getRequestStatus(state),
  touchedFields: state.touchedFields, // ref: used from NewUserAccountTypeRow
  viewRelationships: getViewRelationships(state),
  shouldDisableSave: getShouldDisableSave(state),
  customer: getCustomer(state),
  view: getView(state),
  modifiedActiveSelections: getModifiedActiveSelections(state),
  generateGVAEditPayload:generateGVAEditPayload(state),
});

export default connect(mapStateToProps)(GrantViewAccess);